import { Button, Group, Flex } from "@mantine/core";
import { IconFilter, IconFilterFilled, IconBellFilled } from "@tabler/icons-react";
import { useTheme } from "../contexts/ThemeContext";

interface MobileFiltersProps {
  onBrandClick: () => void;
  onStoreClick: () => void;
  onStockClick: () => void;
  onAlertClick: () => void;
  manufacturerFilter: string[];
  uniqueManufacturers: string[];
  retailerFilter: string[];
  uniqueRetailers: string[];
  stockFilter: string[];
}

export const MobileFilters = ({
  onBrandClick,
  onStoreClick,
  onStockClick,
  onAlertClick,
  manufacturerFilter,
  uniqueManufacturers,
  retailerFilter,
  uniqueRetailers,
  stockFilter,
}: MobileFiltersProps) => {
  const { theme } = useTheme();
  const themeColor = theme === "green" ? "nvidiaGreen" : "amdRed";
  return (
    <Flex align="center" gap="md" mb="md" style={{ width: "100%" }}>
      <Group gap="md">
        <Button
          variant="light"
          color="gray"
          size="xs"
          leftSection={
            manufacturerFilter.length < uniqueManufacturers.length ? (
              <IconFilterFilled size={16} />
            ) : (
              <IconFilter size={16} />
            )
          }
          onClick={onBrandClick}
        >
          Brand
        </Button>
        <Button
          variant="light"
          color="gray"
          size="xs"
          leftSection={
            retailerFilter.length < uniqueRetailers.length ? (
              <IconFilterFilled size={16} />
            ) : (
              <IconFilter size={16} />
            )
          }
          onClick={onStoreClick}
        >
          Store
        </Button>
        <Button
          variant="light"
          color="gray"
          size="xs"
          leftSection={
            stockFilter.length < 4 ? (
              <IconFilterFilled size={16} />
            ) : (
              <IconFilter size={16} />
            )
          }
          onClick={onStockClick}
        >
          Stock
        </Button>
      </Group>
      <Button
        variant="light"
        color={themeColor}
        p="xs"
        onClick={onAlertClick}
        style={{ marginLeft: "auto" }}
      >
        <IconBellFilled size={18} />
      </Button>
    </Flex>
  );
};
